<page-header title="Create Campaign" [showSpinner]="isLoading" [error]="error"></page-header>

<div *ngIf="container && !isLoading">
    <campaign-form *ngIf="!isLoading" [container]="container" (formSubmit)="onSubmit($event)" (formCancelled)="onCancel($event)"></campaign-form> 
</div>